import { useState } from 'react'
import SelectBaseAntd, { SelectBaseAntdProps } from '../SelectBaseAntd'
import useGetFechamentosRateiosPorMes from 'core/features/rateio/hooks/useGetFechamentosRateiosPorMes';

export interface SelectFechamentosRateioPorMesProps<T = any> extends SelectBaseAntdProps<T> {}

function SelectFechamentosRateioPorMes({ ...rest }: SelectFechamentosRateioPorMesProps) {
  const [search, setSearch] = useState<string>()

  const { isLoading, data } = useGetFechamentosRateiosPorMes()

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione..."
      searchValue={search}
      showSearch
      onSearch={setSearch}
      optionFilterProp="label"
      options={data?.items?.map(item => ({
        value: item.id,
        label: item.nome
      }))}
      {...rest}
    />
  )
}

export default SelectFechamentosRateioPorMes
